import * as yup from 'yup';

export const bankTransferValidationSchema = {
    bank: yup.string(),
    branch: yup.string(),
    account: yup.string(),
    reference: yup.string().required('Bank reference is required'),
    iban: yup.string(),
    swiftCode: yup.string(),
    receivingBank: yup.object().nullable().required('Receiving bank is required'),
    valueDate: yup.date().nullable().required('Value date is required')
};
